<template>
    <div>
        <Toolbar>
            <template>
                <BackButton/>
            </template>
        </Toolbar>
        <div class="card card-body">
            <div class="text-xl">
                {{ user.name }}
            </div>
            <div>
                {{ user.email }}
            </div>
            <div>
                {{ user.phone }}
            </div>
        </div>
        <div class="card card-body mt-3">
            <b>{{ startDate }} bis {{ endDate }}</b>
            <table class="table table-hover">
                <thead>
                <tr>
                    <th>Datum</th>
                    <th>Store</th>
                    <th class="text-center">Typ</th>
                    <th>EAN</th>
                    <th class="text-center">Stück</th>
                    <th class="text-right">Preis</th>
                    <th class="text-right">Gesamt</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="entry in data">
                    <td>{{ $localTime(entry.date) }}</td>
                    <td class="text-monospace">{{ entry.store }}</td>
                    <td class="text-center">
                        <span class="label label-inline" :class="{
                            'label-primary': entry.type === 'sale',
                            'label-warning': entry.type !== 'sale'
                        }">{{ entry.type }}<span v-if="entry.type_info">: {{ entry.type_info }}</span></span>
                    </td>
                    <td class="text-monospace">{{ entry.ean }}</td>
                    <td class="text-monospace text-center">{{ entry.quantity }}</td>
                    <td class="text-monospace text-right">{{ entry.price.toFixed(2) }}€</td>
                    <td class="text-monospace text-right">{{ (entry.price * entry.quantity).toFixed(2) }}€</td>
                </tr>
                <tr>
                    <td colspan="7" class="text-right font-weight-bold text-2xl">SUMME {{ total.toFixed(2) }}€</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import BackButton from '@components/BackButton.vue'
import Toolbar from '@components/Toolbar.vue'

export default {
    components: {Toolbar, BackButton},
    props: {
        start: String,
        end: String,
        user: Object,
        data: Array,
    },

    computed: {
        startDate() {
            return this.$localDate(new Date(this.start))
        },
        endDate() {
            return this.$localDate(new Date(this.end))
        },
        total(){
            return this.data.reduce((a, datum) => a + (datum.price * datum.quantity), 0);
        }
    },
}
</script>
